import { MouseEventHandler } from 'react'

import styled from '@emotion/styled'

import { mediaQueryUp } from '~/utils/grid'

import { CloseIcon as ModalCloseIcon, CloseIconContainer } from '~/shared/molecules/Modal/ModalShards'

const IconContainer = styled(CloseIconContainer)`
  pointer-events: auto;

  ${mediaQueryUp('l')} {
    display: none;
  }
`

export const CloseIcon = ({ onClick }: { onClick: MouseEventHandler<HTMLDivElement> }) => {
  return (
    <IconContainer onClick={onClick} isOutside={false} iconSize={'big'}>
      <ModalCloseIcon icon='x' isOutside={false} />
    </IconContainer>
  )
}
